import { create } from '@bufbuild/protobuf';
import {
  AimRequestSchema,
  CreateRoomRequestSchema,
  DequeueRequestSchema,
  EnqueueGroupRequestSchema,
  EnqueueRequestSchema,
  FireRequestSchema,
  FriendsPresenceRequestSchema,
  InviteFriendRequestSchema,
  RefreshProfileRequestSchema,
  JoinRoomRequestSchema,
  KickMemberRequestSchema,
  LeaveRoomRequestSchema,
  ListRoomsRequestSchema,
  MoveRequestSchema,
  PingRequestSchema,
  ResumeRequestSchema,
  SetReadyRequestSchema,
  SkipTurnRequestSchema,
  UseSkillRequestSchema,
  StartGameRequestSchema,
  type ClientMessage,
} from './gen/ddtank/match/v1/match_pb';

type Payload = NonNullable<ClientMessage['payload']>;

/** Construtores das mensagens do cliente: `client.send(msg.move(1))`. */
export const msg = {
  listRooms: (): Payload => ({ case: 'listRooms', value: create(ListRoomsRequestSchema) }),
  createRoom: (options: { name: string; teamSize: number; mapId?: number; password?: string }): Payload => ({
    case: 'createRoom',
    value: create(CreateRoomRequestSchema, { name: options.name, teamSize: options.teamSize, mapId: options.mapId ?? 0, password: options.password ?? '' }),
  }),
  joinRoom: (roomId: string, password = ''): Payload => ({ case: 'joinRoom', value: create(JoinRoomRequestSchema, { roomId, password }) }),
  joinByCode: (code: string): Payload => ({ case: 'joinRoom', value: create(JoinRoomRequestSchema, { code }) }),
  leaveRoom: (): Payload => ({ case: 'leaveRoom', value: create(LeaveRoomRequestSchema) }),
  kickMember: (accountId: string): Payload => ({ case: 'kickMember', value: create(KickMemberRequestSchema, { accountId }) }),
  setReady: (ready: boolean): Payload => ({ case: 'setReady', value: create(SetReadyRequestSchema, { ready }) }),
  startGame: (): Payload => ({ case: 'startGame', value: create(StartGameRequestSchema) }),
  enqueue: (teamSize: number): Payload => ({ case: 'enqueue', value: create(EnqueueRequestSchema, { teamSize }) }),
  enqueueGroup: (): Payload => ({ case: 'enqueueGroup', value: create(EnqueueGroupRequestSchema) }),
  dequeue: (): Payload => ({ case: 'dequeue', value: create(DequeueRequestSchema) }),
  refreshProfile: (): Payload => ({ case: 'refreshProfile', value: create(RefreshProfileRequestSchema) }),
  friendsPresence: (): Payload => ({ case: 'friendsPresence', value: create(FriendsPresenceRequestSchema) }),
  inviteFriend: (accountId: string): Payload => ({ case: 'inviteFriend', value: create(InviteFriendRequestSchema, { accountId }) }),
  move: (direction: -1 | 1): Payload => ({ case: 'move', value: create(MoveRequestSchema, { direction }) }),
  aim: (angle: number): Payload => ({ case: 'aim', value: create(AimRequestSchema, { angle }) }),
  fire: (angle: number, power: number, special = false): Payload => ({ case: 'fire', value: create(FireRequestSchema, { angle, power, special }) }),
  skipTurn: (): Payload => ({ case: 'skipTurn', value: create(SkipTurnRequestSchema) }),
  useSkill: (skillId: number, targetId = ''): Payload => ({ case: 'useSkill', value: create(UseSkillRequestSchema, { skillId, targetId }) }),
  resume: (): Payload => ({ case: 'resume', value: create(ResumeRequestSchema) }),
  ping: (clientTimeMs: number): Payload => ({ case: 'ping', value: create(PingRequestSchema, { clientTimeMs: BigInt(Math.trunc(clientTimeMs)) }) }),
};
